import csvToXml from 'csv-to-xml'
import xlsx from 'json-as-xlsx'
import jsPDF, { TableConfig } from "jspdf"
import { saveAs } from "file-saver"

import { generateProfileSurveyXlsx } from './visitor-profile-xslx-service'
import { generateProfileSurveyPdf } from './visitor-profile-pdf-service'

const { Parser } = require('json2csv')

const pdfTableConfig: TableConfig = {
  fontSize: 10,
  headerBackgroundColor: '#FF5E1E',
  headerTextColor: '#FFF',
}

export class ReportGeneratorService {
  private getContentTypeForFormat = (format: string) => {
    const contentTypeMap = {
      txt: 'text/plain;charset=utf-8;',
      csv: 'text/csv;charset=utf-8;',
      xlsx: 'text/plain;charset=utf-8;',
      xml: 'text/plain;charset=utf-8;',
    }
    return contentTypeMap[format]
  }

  private parseData = (data: any, format, fields?: string[], name?) => {
    if (format === '.csv' || format === '.txt') {
      const parser = new Parser({ fields })
      return parser.parse(data)
    }

    if (format === '.xlsx') {
      const columns = (fields || [])?.map((key) => ({
        value: key,
        label: key,
      }))
      const xlsxData = [
        {
          sheet: 'ItBuzz Report',
          columns,
          content: data,
        },
      ]
      xlsx(xlsxData as any, { fileName: name })
      return false
    }

    if (format === '.xml') {
      const csvParser = new Parser({ fields })
      const csv = csvParser.parse(data) || ''
      const xml = csvToXml(csv?.replaceAll(`"`, ''), {
        headerList: fields,
      })
      return '<table>' + xml + '</table>'
    }

    if (format === '.pdf') {
      const orientation = fields?.length > 3 ? 'l' : 'p'
      const pdf = new jsPDF(orientation, 'pt', 'a3')
      pdf.text('itBuzz Report', 235, 40)
      pdf.table(50, 55, data, fields, pdfTableConfig)
      pdf.save(name)
    }
  }

  generateAndDownloadFile(data, name, format, fields, special = false) {
    if (special) {
      if (format === '.xlsx') generateProfileSurveyXlsx(data, name)
      if (format === '.pdf') generateProfileSurveyPdf(data, name)
    } else {
      const content = this.parseData(data, format, fields, name)
      if (content) {
        this.downloadBlob(
          content,
          name + format,
          this.getContentTypeForFormat(format)
        )
      }
    }
  }

  private downloadBlob(content, filename, contentType) {
    var blob = new Blob([content], { type: contentType })
    saveAs(blob, filename)
  }
}
